import { render, staticRenderFns } from "./stateGk.vue?vue&type=template&id=ec0a82fc&scoped=true"
import script from "./stateGk.vue?vue&type=script&lang=js"
export * from "./stateGk.vue?vue&type=script&lang=js"
import style0 from "./stateGk.vue?vue&type=style&index=0&id=ec0a82fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0a82fc",
  null
  
)

export default component.exports